import styled from "styled-components";

export const ContainerConfirmEmailHeader = styled.header`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 16px 0px;
  margin-left: auto;
  margin-right: auto;

  @media (min-width: 428px) {
    max-width: 396px;
  }

  @media (min-width: 744px) {
    max-width: 712px;
  }

  @media (min-width: 1024px) {
    max-width: 976px;
  }

  @media (min-width: 1024px) {
    max-width: 1396px;
  }
`;

export const LogoConfirmPage = styled.h1`
  font-size: 24px;
  font-weight: 500;
  line-height: 1.2;

  @media (min-width: 744px) {
    font-size: 32px;
    font-weight: 500;
    line-height: 1.18;
  }

  @media (min-width: 1440px) {
    font-size: 36px;
    font-weight: 500;
    line-height: 1.19;
  }
`;

export const LogoConfirmPageColor = styled.span`
  color: #1ac63f;
`;

export const NameUser = styled.h1`
  font-size: 24px;
  font-weight: 500;
  line-height: 1.2;

  @media (min-width: 744px) {
    font-size: 32px;
    font-weight: 500;
    line-height: 1.18;
  }

  @media (min-width: 1440px) {
    font-size: 36px;
    font-weight: 500;
    line-height: 1.19;
  }
`;

export const NameUserColor = styled.span`
  color: #1ac63f;
`;
